import React from 'react';
import axios from 'axios';
import Subject from './Subject';
import SubjectView from './SubjectView';


import * as Globals from './../Globals';

export default class SubjectOverview extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            subjects: [],
            viewID: -1
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.BASE_PATH + 'api/subjects',
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie
                }
            }).then(response => {
            this.setState({
                subjects: response.data.data
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
        });
    }

    handleViewRequest(id) {
        this.setState({
            viewID: id
        });
    }

    handleSubjectListRequest() {
        this.setState({
            viewID: -1
        });
    }

    getRenderBlock() {
        if (this.state.viewID < 0) {
            return (
                <div className="container subjects">
                    <h1 className="text-center">Fächer</h1>
                    <ul className="list-group">
                        {(this.state.subjects.length === 0) ?
                            <li className="list-group-item"><p className="text-center" style={{margin: 0}}><b>Fächer
                                werden geladen oder sind nicht vorhanden...</b></p></li> : null}
                        {
                            this.state.subjects.map((subject) => {
                                return (
                                    <Subject CheckAuthError={this.props.CheckAuthError} key={subject.id} id={subject.id}
                                             name={subject.name} topics={subject.clear
                                             }
                                             sendViewRequest={this.handleViewRequest.bind(this)}/>
                                );
                            })
                        }
                    </ul>
                </div>
            );
        } else {
            return (
                <div>
                    <SubjectView CheckAuthError={this.props.CheckAuthError}
                                 LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} id={this.state.viewID}
                                 sendSubjectListRequest={this.handleSubjectListRequest.bind(this)}/>
                </div>
            );
        }
    }

    render() {
        return (this.getRenderBlock());
    }

}



// WEBPACK FOOTER //
// ./src/admin/SubjectOverview.js